module.exports = __webpack_public_path__ + "static/Qu-29b44bed9d937a89b260382a58afbd23.jpg";